import { Component, OnInit } from '@angular/core';
import { UiTable } from "../../../../../components/ui/table/table.component";
import { TableStructures } from '../../../../../data/schemas/table.schema';
import { StructureService } from '../../../../../services/StructureService';
import { ModalComponent } from "../../../../../components/modal/modal.component";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Input } from "../../../../../components/forms/input/input";
import { StructureResponse } from '../../../../../data/http/responses/strcuture.res';
import { AppService } from '../../../../../core/app.service';
import { SelectComponent } from "../../../../../components/forms/select/select.component";
import { SelectOption } from '../../../../../data/schemas/selectoption.schema';
import { UiButtonComponent } from '../../../../../components/button/button.component';
import { loaderIntervantion } from '../../../../../components/ui/loaderIntervantion/loaderIntervantion.component';
import { ConfirmDialogComponent } from '../../../../../components/ui/Confirmdialog/Confirmdialog.component';

@Component({
  selector: 'app-structures',
  standalone: true,
  imports: [
    UiTable,
    ModalComponent,
    ReactiveFormsModule,
    Input,
    SelectComponent,
    UiButtonComponent,
    loaderIntervantion,
    ConfirmDialogComponent
  ],
  templateUrl: './structures.component.html',
  styleUrl: './structures.component.css'
})
export class StructuresPage implements OnInit {
  public tableStructures = TableStructures;
  public showAddStructuresModal: boolean = false;
  public structures: StructureResponse[] = [];
  public structuresOptions: SelectOption[] = [];
  public isLoading: boolean = false;
  public isEditing: boolean = false;
  public editingStructure: StructureResponse | null = null;

  // Confirmation suppression
  public showDeleteConfirm: boolean = false;
  public selectedItem: StructureResponse | null = null;
  public deleteLoading: boolean = false;

  structureForm!: FormGroup;

  constructor(
    private structureService: StructureService,
    private fb: FormBuilder,
    private appService: AppService
  ) {
    this.structureForm = this.fb.group({
      applicationId: this.appService.getAppId(),
      libelle: ['', Validators.required],
      code: ['', Validators.required],
      mere: [''],
    });
  }

  ngOnInit(): void {
    this.loadStructures();
  }

  saveStructure(): void {
    if (this.structureForm.valid) {
      const appId = this.appService.getAppId();
      if (!appId || appId === 'null') return;

      this.isLoading = true;
      const requestBody = { ...this.structureForm.value, applicationId: appId };

      if (this.isEditing && this.editingStructure) {
        this.structureService.update(this.editingStructure.id, requestBody).subscribe({
          next: () => {
            this.loadStructures();
            this.closeAddStructures();
            this.isLoading = false;
          },
          error: (error) => {
            console.error('Erreur mise à jour :', error);
            this.isLoading = false;
          }
        });
      } else {
        this.structureService.create(requestBody).subscribe({
          next: () => {
            this._resetForm();
            this.loadStructures();
            this.closeAddStructures();
            this.isLoading = false;
          },
          error: (error) => {
            console.error('Erreur création :', error);
            this.isLoading = false;
          }
        });
      }
    } else {
      this.structureForm.markAllAsTouched();
    }
  }

  loadStructures(): void {
    this.isLoading = true;
    this.structureService.getAllByAppId(this.appService.getAppId()).subscribe({
      next: (response: any) => {
        const rawStructures: any[] = response.data;
        const transformedStructures: StructureResponse[] = [];
        const structureMap = new Map<string, StructureResponse>();

        rawStructures.forEach(raw => {
          const s: StructureResponse = {
            id: raw.id,
            raisonSociale: raw.raisonSociale,
            libelle: raw.libelle,
            code: raw.code,
            enfants: []
          };
          transformedStructures.push(s);
          structureMap.set(s.id, s);
        });

        rawStructures.forEach(raw => {
          const current = structureMap.get(raw.id);
          if (current && raw.filles?.length > 0) {
            raw.filles.forEach((filleRaw: any) => {
              const child = structureMap.get(filleRaw.id);
              if (child) {
                child.mere = {
                  id: current.id,
                  libelle: current.libelle,
                  code: current.code,
                  raisonSociale: current.raisonSociale,
                  enfants: []
                };
                current.enfants.push(child);
              }
            });
          }
        });

        this.structures = transformedStructures;
        this.structuresOptions = response.data.map((item: StructureResponse) => ({
          value: item.id,
          label: item?.libelle
        }));
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Erreur chargement :', error);
        this.isLoading = false;
      }
    });
  }

  openAddStructures(): void {
    this.isEditing = false;
    this.editingStructure = null;
    this._resetForm();
    this.showAddStructuresModal = true;
  }

  closeAddStructures(): void {
    this.showAddStructuresModal = false;
    this.isEditing = false;
    this.editingStructure = null;
    this._resetForm();
  }

  onEditTask(item: StructureResponse): void {
    this.isEditing = true;
    this.editingStructure = item;
    this.structureForm.patchValue({
      libelle: item.libelle,
      raisonSociale: item.raisonSociale,
      code: item.code,
      applicationId: this.appService.getAppId()
    });
    this.showAddStructuresModal = true;
  }

  openDeleteConfirm(item: StructureResponse): void {
    this.selectedItem = item;
    this.showDeleteConfirm = true;
  }

  cancelDelete(): void {
    this.showDeleteConfirm = false;
    this.selectedItem = null;
  }

  confirmDelete(): void {
    if (!this.selectedItem) return;
    this.deleteLoading = true;
    this.structureService.delete(this.selectedItem.id).subscribe({
      next: () => {
        this.loadStructures();
        this.deleteLoading = false;
        this.cancelDelete();
      },
      error: (error) => {
        console.error('Erreur suppression :', error);
        this.deleteLoading = false;
      }
    });
  }

  private _resetForm(): void {
    this.structureForm.reset({
      applicationId: this.appService.getAppId(),
      libelle: '',
      code: '',
      mere: ''
    });
  }
}